import React, { memo } from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-violet/15" data-id="element-441">
    <div className="flex items-center mb-4" data-id="element-442">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-violet font-serif font-bold text-sm md:text-xl border border-brand-violet/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-443">
        {initials}
      </div>
      <div data-id="element-444">
        <div className="flex text-brand-goldDark mb-1 text-[15px]" data-id="element-445">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-446" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-447">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-448">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] font-serif leading-relaxed" data-id="element-449">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [];
  return <Section className="pt-8 pb-16" data-id="element-450">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-451">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-452" />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'VR',
    name: 'Valentina R.',
    location: 'Terapeuta en Registros Akáshicos',
    product: 'Kit Terapeuta PRO',
    text: 'Antes vivía buscando la hoja del paciente que atendí el martes. Ahora abro el Kit y en 30 segundos tengo todo. Parece simple pero cambió completamente cómo me siento en cada sesión.'
  }, {
    initials: 'CM',
    name: 'Carolina M.',
    location: 'Consteladora Familiar',
    product: 'Kit + Marketing',
    text: 'Dejé de depender de mi memoria. Eso solo ya vale todo. Ahora cada sesión tiene hilo conductor y mis pacientes lo notan.'
  }, {
    initials: 'LB',
    name: 'Lucía B.',
    location: 'Terapeuta Reiki y Flores de Bach',
    product: 'Kit Terapeuta PRO',
    text: 'Mi consulta por fin tiene estructura. Me siento profesional de verdad — no solo como terapeuta formada, sino como práctica organizada.'
  }, {
    initials: 'SA',
    name: 'Sofía A.',
    location: 'Biodescodificadora',
    product: 'Kit + Marketing',
    text: 'Las sesiones ahora tienen continuidad. Los pacientes vuelven con más compromiso porque sienten que hay un proceso real, no solo una charla.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-453">
      <div className="text-center mb-12" data-id="element-454">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-violetDark pt-[0px]" data-id="element-455">
          ❤️ LO QUE DICEN LOS TERAPEUTAS QUE YA TIENEN SU SISTEMA
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] max-w-4xl mx-auto" data-id="element-456">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-457" />)}
      </div>
    </Section>;
};